var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.607 25.517-5.94 4.667V5.517A1.333 1.333 0 0 1 4 4.184h24a1.333 1.333 0 0 1 1.334 1.333v18.667A1.333 1.333 0 0 1 28 25.517H8.607zm-.923-2.667h18.983v-16H5.334v17.847l2.35-1.847zm2.983-9.333h10.667v2.667H10.667v-2.667z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLine);
export default __webpack_public_path__ + "static/media/message-line.4e0688183d84f9e235ecedd35a4e2b4c.svg";
export { ForwardRef as ReactComponent };